import { Component, OnInit } from '@angular/core';
import { PortalReportsService } from '../../Services/portal-reports.service';
import {TranslateService} from "@ngx-translate/core";
declare const $;


@Component({
  selector: 'app-leader-board',
  templateUrl: './leader-board.component.html',
  styleUrls: ['./leader-board.component.css'],
  providers : [PortalReportsService]
})
export class LeaderBoardComponent implements OnInit {

  searchMsgTitle: string = "";
  sEmptyTable: string;
  sLengthMenu: string;
  sInfoEmpty: string;
  oPaginate: any;
  sInfo: string;
  sZeroRecords: string;
  sProcessing: string;
  sLoadingRecords: string;
  role: string = "";

  constructor(private portalReportsService : PortalReportsService, private translate: TranslateService) {

  }

  leaderBoardList : Array<any> = [];
  hidetable : boolean = true;

  ngOnInit() {
    $(document).ready(function() {
      $("#disablePrevent").on("contextmenu",function(){
        return false;
      });
    });
    let lang_name = localStorage.getItem('defaultLang');
    this.translate.use(lang_name);
    this.role = localStorage.getItem('userRole');
    $("#preloader").css('display','block');
    this.translate.get(['sEmptyTable', 'sLengthMenu', 'sInfoEmpty', 'oPaginate', 'sInfo', 'sZeroRecords', 'sProcessing', 'SEARCH_LEADERBOARD']).subscribe(label => {
      this.sEmptyTable = label.sEmptyTable;
      this.sLengthMenu = label.sLengthMenu;
      this.sInfoEmpty = label.sInfoEmpty;
      this.oPaginate = label.oPaginate;
      this.sInfo = label.sInfo;
      this.sZeroRecords = label.sZeroRecords;
      this.sProcessing = label.sProcessing;
      this.sLoadingRecords = label.sLoadingRecords;
      this.searchMsgTitle = label.SEARCH_LEADERBOARD;
      this.showLeaderBoard();
    });
  }

  showLeaderBoard(){
    localStorage.setItem('currentScreen', 'LEADER_BOARD');
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    let comm_id = currentUser.user.community_id;
    this.portalReportsService.getLeaderBoard(comm_id).subscribe(list =>{
      /* $("#preloader").css('display','none');*/
      if(list.success) {
        this.leaderBoardList = list.data;

        this.hidetable = true;
        let leaderBoard = $("#leaderBoard").DataTable();
        leaderBoard.destroy();

        $("#leaderBoard").DataTable({
          data: this.leaderBoardList,
          "autoWidth": false,
          "columns": [
            {"data": "user_name"},
            {"data": "score"}
          ],
          "language": {
            searchPlaceholder: this.searchMsgTitle,
            sEmptyTable: this.sEmptyTable,
            sSearch: "",
            sLengthMenu: this.sLengthMenu,
            sInfoEmpty: this.sInfoEmpty,
            oPaginate: this.oPaginate,
            sInfo: this.sInfo,
            sProcessing: this.sProcessing,
            sZeroRecords: this.sZeroRecords,
            sLoadingRecords: this.sLoadingRecords
          },
          'initComplete': () => {
            $("#preloader").css('display', 'none');
            this.hidetable = false;
          },
          "processing": false,
          "serverSide": false,
          "order": [1, 'desc'],
          "columnDefs": [
            {'width': '50%', 'targets': 0},
            {'width': '50%', 'targets': 1}
          ]
        });

        $('table#leaderBoard').on('preXhr.dt', function (e, settings, data) {
          data.search.value = data.search.value.trim();
        });
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/Screens/leader-board/leader-board.component.ts